<template>
    <v-btn
        class="px-0 app-btn"
        :color="color"
        elevation="2"
        :large="large"
        v-bind="$attrs"
        v-on="$listeners">
        <v-icon v-if="icon" class="app-btn-icon pl-5">
            {{ icon }}
        </v-icon>
        <span class="px-5 flex-grow-1 text-capitalize"><slot /></span>
    </v-btn>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: "primary"
        },
        icon: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
        large: {
            type: Boolean,
            default: true
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../assets/style/theme.scss";

.app-btn-icon {
    height: 36px;
    width: 36px;
    border-radius: 50%;
    font-size: 22px;
    margin-right: -5px;
}
.app-btn.v-size--large {
    color: #ffffff;
    font-size: 1rem;
    border-radius:16px;
    border-width: 2px;
}

</style>
